import React, { Suspense, useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Header from "../../DefaultLayout/Header";
import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";
import {
  Col,
  FormGroup,
  Row,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from "reactstrap";
import {
  FaPlusCircle,
  FaCalendarAlt,
  FaFileUpload,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
// css
import "../Renters_info/Renters_info.css";
import "./Non_register_user.css";
import "react-datepicker/dist/react-datepicker.css";

import $ from "jquery";
import Select from "react-select";

import {
  checkEmailValidation,
  checkEmptyValidation,isFutureDate,checkMobileNumberValidation,checkRequiredValidationWithMinMax,checkRequiredTextValidationWithMinMax
} from "../../Helpers/Validation";
import { connect } from "react-redux";
import CheckboxTree from "react-checkbox-tree";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,

  MdAdd,
  MdRemove,
} from "react-icons/md";
import { addRentersList } from "../../actions/propertyAction";
import { useHistory, Redirect } from "react-router-dom";
import { dropdownPropertyField } from "../../actions/propertyFieldAction";
import { toast } from "react-toastify";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
import {
 
  CircularProgress,
} from "@mui/material";

import Nodes from "../../Helpers/nodesList.js";
const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};


const Non_registered_user1 = (props) => {
  const { frontLabelsName } = props.label;
  const lng = localStorage.getItem("prevLangFront") ;
 const nodes = Nodes(); 
  const { isAuthenticated, loading } = props.auth;
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const modalHandle = () => setModal(!modal);

  const [full_name, setFull_name] = useState("");
  const [email, setEmail] = useState("");
  const [profile_pic, setProfile_pic] = useState("");
  const [profile_pic1, setProfile_pic1] = useState("");
  const [profile_pic2, setProfile_pic2] = useState("");
  const [profile_pic_url, setProfile_pic_url] = useState("");
  const [profile_pic_url1, setProfile_pic_url1] = useState("");
  const [address, setAddress] = useState("");
  const [mobile_number, setMobileNumber] = useState("");
  const [ss_number, setSs_number] = useState("");
  const [zcode, setZcode] = useState("");
  const [nationality, setNationality] = useState("");

  const [budget, setBudget] = useState("");
  const [depositType, setDepositType] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [familySize, setFamilySize] = useState("");
  const [child, setChild] = useState("");
  const [workPerson, setWorkPerson] = useState("");
  const [typeOfWork, setTypeOfWork] = useState("");
  const [spouseOfWork, setSpouseOfWork] = useState("");

  const [creditType, setCreditType] = useState(false);
  const [recommendationType, setReccomendationType] = useState(false);
  const [otherType, setOtherType] = useState(false);

      const[creditFileName,setCreditFileName] = useState("");
      const[recomendationFileName,setRecomendationFileName]= useState("");
      const[otherFileName,setOtherFileName]= useState("");

  const [creditUploadUrl, setCreditUploadUrl] = useState("");
  const [creditUploadPreview, setCreditUploadPreview] = useState("");
  const [recommendationUploadPreview, setRecommendationUploadPreview] =
    useState("");
  const [recommendationUploadUrl, setRecommendationUploadUrl] = useState("");

  const [otherUploadUrl, setOtherUploadUrl] = useState("");
  const [otherUploadPreview, setOtherUploadPreview] = useState("");

  const [bhk, setBhk] = useState([]);
  const [availableFrom, setAvailableFrom] = useState(null);
  const [availableTo, setAvailableTo] = useState(null);


  const [propertyType, setPropertyType] = useState([]);
  const [priceFrom, setPriceFrom] = useState("");
  const [priceTo, setPriceTo] = useState("");

  const [checkedTree, setCheckedTree] = useState(["0"]);
  const [expandedTree, setExpandedTree] = useState(["0"]);

  const [clickedTree, setClickedTree] = useState([]);
  const [openZip, setOpenZip] = useState(false);

  const [shortTerm, setShortTerm] = useState(true);
  const [longTerm, setLongTerm] = useState(false);
  const [termsCheckbox, setTermsCheckbox] = useState(false);
  const [errorProfile, setErrorProfile] = useState("");

  const[disableSubmitButton,setDisableSubmitButton]=useState(false)

  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherTypeField, setOtherTypeField] = useState([]);

  const [selectedOtherData, setSelectedOtherData] = useState([]);
  const [selectedAccessData, setSelectedAccessData] = useState([]);
  const [selectedHomeApplianceData, setSelectedHomeApplianceData] = useState(
    []
  );
  const [selectedRestrictionData, setSelectedRestrictionData] = useState([]);
  const [creditImageError, setCreditImageError] = useState("");
  const [reccomendationImageError, setReccomendationImageError] = useState("");
  const [otherImageError, setOtherImageError] = useState("");
  const [errors, setErrors] = useState({
    errorName: "",
    errorEmail: "",
    errorAddress: "",
    errormobile: "",

    errorSs: "",
    errorZCode: "",
    errorNationality: "",

    errBudget: "",
    errDepositType: "",
    errDepositAmount: "",
    errFamilySize: "",
    errChild: "",
    errWorkPerson: "",
    errTypeOfWork: "",
    errSpouseOfWork: "",

    errBhk: "",
    errAvailableFrom: "",
    errAvailableTo: "",
    errOther: "",
    errAccess: "",
    errRestriction: "",
    errHomeAppliance: "",
    errPropertyType: "",
    errPriceFrom: "",
    errPriceTo: "",
    errZip: "",

    errCheckbox: "",
  });

  useEffect(() => {
    props.dropdownPropertyField("").then((res) => {
      // setIncluded(res?.type_1);
      setHomeApplianceType(res?.type_2);
      setRestrictionsType(res?.type_3);
      setAccessType(res?.type4);
      setOtherTypeField(res?.type5);
    });
  }, []);

  const handleUpload = () => {
    $("#handleupload").trigger("click");
  };

  const handleFileChange = (e) => {
    e.preventDefault();
    let validationFlag = true;

    if (e.target.files.length) {
      let file = e.target.files[0];
      const imageSize = e.target.files[0].size / 1024 / 1024;
      if (!file.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
        setErrorProfile(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")
                .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")[0][
                  "value"
                ] || "lbl_select_valid_image"
              : "lbl_select_valid_image"
            : "lbl_select_valid_image"
        );
        validationFlag = false;
      } else if (imageSize > 10) {
        setErrorProfile(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_image_less_than_10mb")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_image_less_than_10mb"
                )[0]["value"] || "lbl_image_less_than_10mb"
              : "lbl_image_less_than_10mb"
            : "lbl_imag_less_than_10mbe"
        );
        validationFlag = false;
      } else {
        validationFlag = true;
        setErrorProfile("");
      }

      if (validationFlag) {
        // setProfile_pic_url(file);
        setProfile_pic_url1(file);
        setProfile_pic2(URL.createObjectURL(e.target.files[0]));
        setProfile_pic(URL.createObjectURL(e.target.files[0]));
      }
    }
  };

  const confirmImage = () => {
    setProfile_pic1(profile_pic);
    setProfile_pic_url(profile_pic_url1);
    setModal(!modal);
    setProfile_pic("");
    setProfile_pic_url1("");
  };

  const cancelImage = () => {
    setProfile_pic_url1("");
    setProfile_pic("");
    setModal(!modal);
  };

  const options = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house",
      value: "detachedHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex",
      value: "duplex",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house",
      value: "tripleAptHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
            "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building",
      value: "aptBulding",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin",
      value: "townhouseTwin",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage",
      value: "garage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
            "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house",
      value: "summerHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
            "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant",
      value: "cotenant",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house",
      value: "hotelGesthouse",
    },
  ];

  const bhkOptions = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage",
      value: "Storage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_single_room").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_single_room")[0]["value"] ||
            "lbl_single_room"
          : "lbl_single_room"
        : "lbl_single_room",
      value: "Single Room",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_studio").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_studio")[0]["value"] ||
            "lbl_studio"
          : "lbl_studio"
        : "lbl_studio",
      value: "Studio",
    },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9+", value: "9+" },
  ];

  const handleChange = (selectedOption) => {
    setPropertyType(selectedOption);
  };
  const handleBhkChange = (selectedOption) => {
    setBhk(selectedOption);
  };

  const handleZipCode = () => {
    setOpenZip(!openZip);
    // setMenuOpen(!menuOpen);
  };
  const handleCreditUpload = (e) => {
    $("#imgupload").trigger("click");
  };
  const handleFileChange1 = (e) => {
    e.preventDefault();
    let validationFlag = true;
    let imageFile = e.target.files[0];
    const imageSize = e.target.files[0]?.size / 1024 / 1024;
    if (imageFile && !imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|PDF|pdf)$/)) {
      setCreditImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")
              .length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")[0][
                "value"
              ] || "lbl_select_valid_image"
            : "lbl_select_valid_image"
          : "lbl_select_valid_image"
      );
      validationFlag = false;
    } else if (imageSize > 10) {
      setCreditImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_image_less_than_10mb")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_image_less_than_10mb"
              )[0]["value"] || "lbl_image_less_than_10mb"
            : "lbl_image_less_than_10mb"
          : "lbl_imag_less_than_10mbe"
      );
      validationFlag = false;
    } else {
      validationFlag = true;
      setCreditImageError("");
      if (e.target.files && e.target.files.length) {
        let file = e.target.files[0];
        if (file.type.split("/")[1] === "pdf") {
          setCreditType(true);
          setCreditFileName(file.name)
        } else {
          setCreditType(false);
          setCreditFileName('')
        
  
        }
        if (validationFlag) {
          setCreditUploadUrl(file);
  
          setCreditUploadPreview(URL.createObjectURL(e.target.files[0]));
        }
      }
    }
 
  };

  const handleRecommendationUpload = () => {
    $("#imgupload2").trigger("click");
  };
  const handleFileChange2 = (e) => {
    e.preventDefault();
    let validationFlag = true;
    let imageFile = e.target.files[0];
    const imageSize = e.target.files[0]?.size / 1024 / 1024;
    if (imageFile && !imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|PDF|pdf)$/)) {
      setReccomendationImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")
              .length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")[0][
                "value"
              ] || "lbl_select_valid_image"
            : "lbl_select_valid_image"
          : "lbl_select_valid_image"
      );
      validationFlag = false;
    } else if (imageSize > 10) {
      setReccomendationImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_image_less_than_10mb")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_image_less_than_10mb"
              )[0]["value"] || "lbl_image_less_than_10mb"
            : "lbl_image_less_than_10mb"
          : "lbl_imag_less_than_10mbe"
      );
      validationFlag = false;
    } else {
      validationFlag = true;
      setReccomendationImageError("");
    if (e.target.files && e.target.files.length) {
      let file = e.target.files[0];
      if (file.type.split("/")[1] === "pdf") {
        setReccomendationType(true);
        setRecomendationFileName(file.name)
      } else {
        setReccomendationType(false);
        setRecomendationFileName("")
      }
      if (validationFlag) {
        setRecommendationUploadUrl(file);

        setRecommendationUploadPreview(URL.createObjectURL(e.target.files[0]));
      }
    }
  }
  };

  const handleOtherUpload = () => {
    $("#imgupload3").trigger("click");
  };
  const handleFileChange3 = (e) => {
    e.preventDefault();
    let validationFlag = true;
    let imageFile = e.target.files[0];
    const imageSize = e.target.files[0]?.size / 1024 / 1024;
    if (imageFile && !imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|PDF|pdf)$/)) {
      setOtherImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")
              .length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_select_valid_image")[0][
                "value"
              ] || "lbl_select_valid_image"
            : "lbl_select_valid_image"
          : "lbl_select_valid_image"
      );
      validationFlag = false;
    } else if (imageSize > 10) {
      setOtherImageError(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_image_less_than_10mb")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_image_less_than_10mb"
              )[0]["value"] || "lbl_image_less_than_10mb"
            : "lbl_image_less_than_10mb"
          : "lbl_imag_less_than_10mbe"
      );
      validationFlag = false;
    } else {
      validationFlag = true;
      setOtherImageError("");
    if (e.target.files && e.target.files.length) {
      let file = e.target.files[0];
      if (file.type.split("/")[1] === "pdf") {
        setOtherType(true);
        setOtherFileName(file.name)
      } else {
        setOtherType(false);
        setOtherFileName('')
      }
      if (validationFlag) {
        setOtherUploadUrl(file);

        setOtherUploadPreview(URL.createObjectURL(e.target.files[0]));
      }
    }
  }
  };

  const subscribeHandler = () => {
    let validationFlag = true;

    let err_name = "";
    let err_email = "";
    let err_address = "";
    let err_mobile = "";
    let err_nationality = "";
    let err_ss = "";
    let err_z_code = "";
    let err_zip_code = "";
    let err_property_type = "";
    let err_bhk = "";
    let err_available_to = "";
    let err_other = "";
    let err_access = "";
    let err_home_appliance = "";
    let err_restriction = "";
    let err_checkbox = "";

    err_name = checkRequiredTextValidationWithMinMax(full_name.trim(), "lbl_full_name",2,50);
    err_nationality = checkEmptyValidation(nationality.trim(), "lbl_nationality");
    err_email = checkEmailValidation(email.trim(), "lbl_email");
    err_address = checkEmptyValidation(address.trim(), "lbl_address");
    err_ss = checkRequiredValidationWithMinMax(ss_number.trim(), "lbl_social_security_no",7,11);
    err_z_code = checkEmptyValidation(zcode, "lbl_zip_code");
    err_mobile = checkMobileNumberValidation(mobile_number, "lbl_phone_number",5,16);
    let err_budget = checkEmptyValidation(budget, "lbl_budget");
    let err_deposit_type = checkEmptyValidation(
      depositType,
      "lbl_deposit_type"
    );
    let err_deposit_amount = checkEmptyValidation(
      depositAmount,
      "lbl_deposit_amount"
    );
    let err_family_size = checkEmptyValidation(familySize, "lbl_family_size");
    let err_child = checkEmptyValidation(child, "lbl_number_of_child");
    let err_work_person = checkEmptyValidation(
      workPerson,
      "lbl_number_of_work_person"
    );
    let err_type_of_work = checkEmptyValidation(
      typeOfWork,
      "lbl_man_type_of_work"
    );
    let err_spouse_type_of_work = checkEmptyValidation(
      spouseOfWork,
      "lbl_spouse_type_of_work"
    );
    if (bhk.length === 0) {
      err_bhk = checkEmptyValidation(bhk, "lbl_BHK");
    }
    let err_available_from = isFutureDate(
      availableFrom,
      "lbl_available_from"
    );

    if (shortTerm) {
      err_available_to = isFutureDate(availableTo, "lbl_available_to");
    }
    // if (selectedOtherData.length < 2) {
    //   err_other = "lbl_please_select_other";
    // }
    // if (selectedAccessData.length < 2) {
    //   err_access = "lbl_please_select_minimum_2_access";
    // }
    // if (selectedHomeApplianceData.length < 2) {
    //   err_home_appliance = "lbl_please_select_minimum_2_home_appliance";
    // }
    // if (selectedRestrictionData.length < 2) {
    //   err_restriction = "lbl_please_select_minimum_2_restrictions";
    // }
    let err_price_from = checkEmptyValidation(priceFrom, "lbl_price_from");
    let err_price_to = checkEmptyValidation(priceTo, "lbl_price_to");
    if (propertyType.length === 0) {
      err_property_type = "lbl_select_property_type";
    }
  
    if (checkedTree[0]=="0"|| checkedTree.length==0 ) {
      err_zip_code = "lbl_select_zip_code";
    }
    if (termsCheckbox === false) {
      err_checkbox = "lbl_terms_&_agreement";
    }

    if (
      err_name ||
      err_email ||
      err_address ||
      err_ss ||
      err_z_code ||
      err_mobile ||
      err_budget ||
      err_deposit_type ||
      err_deposit_amount ||
      err_family_size ||
      err_child ||
      err_work_person ||
      err_type_of_work ||
      err_spouse_type_of_work ||
      err_bhk ||
      err_available_from ||
      err_available_to ||
      err_other ||
      err_home_appliance ||
      err_restriction ||
      err_access ||
      err_price_from ||
      err_price_to ||
      err_property_type ||
      err_zip_code ||
      err_checkbox ||
      err_nationality
    ) {
      validationFlag = false;
      setErrors({
        errorNationality: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_nationality).length > 0
            ? frontLabelsName.filter((e) => e.key == err_nationality)[0]["value"] ||
              err_nationality
            : err_nationality
          : err_nationality,
        errorName: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_name).length > 0
            ? frontLabelsName.filter((e) => e.key == err_name)[0]["value"] ||
              err_name
            : err_name
          : err_name,
        errorEmail: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_email).length > 0
            ? frontLabelsName.filter((e) => e.key == err_email)[0]["value"] ||
              err_email
            : err_email
          : err_email,
        errorAddress: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_address).length > 0
            ? frontLabelsName.filter((e) => e.key == err_address)[0]["value"] ||
              err_address
            : err_address
          : err_address,
        errorSs: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_ss).length > 0
            ? frontLabelsName.filter((e) => e.key == err_ss)[0]["value"] || err_ss
            : err_ss
          : err_ss,
        errorZCode: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_z_code).length > 0
            ? frontLabelsName.filter((e) => e.key == err_z_code)[0]["value"] ||
              err_z_code
            : err_z_code
          : err_z_code,
        errormobile: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_mobile).length > 0
            ? frontLabelsName.filter((e) => e.key == err_mobile)[0]["value"] ||
              err_mobile
            : err_mobile
          : err_mobile,
        errBudget: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_budget).length > 0
            ? frontLabelsName.filter((e) => e.key == err_budget)[0]["value"] ||
              err_budget
            : err_budget
          : err_budget,
        errDepositType: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_deposit_type).length > 0
            ? frontLabelsName.filter((e) => e.key == err_deposit_type)[0]["value"] ||
              err_deposit_type
            : err_deposit_type
          : err_deposit_type,
        errDepositAmount: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_deposit_amount).length > 0
            ? frontLabelsName.filter((e) => e.key == err_deposit_amount)[0][
                "value"
              ] || err_deposit_amount
            : err_deposit_amount
          : err_deposit_amount,
        errFamilySize: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_family_size).length > 0
            ? frontLabelsName.filter((e) => e.key == err_family_size)[0]["value"] ||
              err_family_size
            : err_family_size
          : err_family_size,
        errChild: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_child).length > 0
            ? frontLabelsName.filter((e) => e.key == err_child)[0]["value"] ||
              err_child
            : err_child
          : err_child,
        errWorkPerson: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_work_person).length > 0
            ? frontLabelsName.filter((e) => e.key == err_work_person)[0]["value"] ||
              err_work_person
            : err_work_person
          : err_work_person,
        errTypeOfWork: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_type_of_work).length > 0
            ? frontLabelsName.filter((e) => e.key == err_type_of_work)[0]["value"] ||
              err_type_of_work
            : err_type_of_work
          : err_type_of_work,
        errSpouseOfWork: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_spouse_type_of_work).length >
            0
            ? frontLabelsName.filter((e) => e.key == err_spouse_type_of_work)[0][
                "value"
              ] || err_spouse_type_of_work
            : err_spouse_type_of_work
          : err_spouse_type_of_work,
        errBhk: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_bhk).length > 0
            ? frontLabelsName.filter((e) => e.key == err_bhk)[0]["value"] || err_bhk
            : err_bhk
          : err_bhk,
        errAvailableFrom: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_available_from).length > 0
            ? frontLabelsName.filter((e) => e.key == err_available_from)[0][
                "value"
              ] || err_available_from
            : err_available_from
          : err_available_from,
        errAvailableTo: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_available_to).length > 0
            ? frontLabelsName.filter((e) => e.key == err_available_to)[0]["value"] ||
              err_available_to
            : err_available_to
          : err_available_to,
        errOther: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_other).length > 0
            ? frontLabelsName.filter((e) => e.key == err_other)[0]["value"] ||
              err_other
            : err_other
          : err_other,
        errAccess: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_access).length > 0
            ? frontLabelsName.filter((e) => e.key == err_access)[0]["value"] ||
              err_access
            : err_access
          : err_access,
        errRestriction: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_restriction).length > 0
            ? frontLabelsName.filter((e) => e.key == err_restriction)[0]["value"] ||
              err_restriction
            : err_restriction
          : err_restriction,
        errHomeAppliance: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_home_appliance).length > 0
            ? frontLabelsName.filter((e) => e.key == err_home_appliance)[0][
                "value"
              ] || err_home_appliance
            : err_home_appliance
          : err_home_appliance,
        errPropertyType: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_property_type).length > 0
            ? frontLabelsName.filter((e) => e.key == err_property_type)[0][
                "value"
              ] || err_property_type
            : err_property_type
          : err_property_type,
        errPriceFrom: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_price_from).length > 0
            ? frontLabelsName.filter((e) => e.key == err_price_from)[0]["value"] ||
              err_price_from
            : err_price_from
          : err_price_from,
        errPriceTo: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_price_to).length > 0
            ? frontLabelsName.filter((e) => e.key == err_price_to)[0]["value"] ||
              err_price_to
            : err_price_to
          : err_price_to,
        errZip: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_zip_code).length > 0
            ? frontLabelsName.filter((e) => e.key == err_zip_code)[0]["value"] ||
              err_zip_code
            : err_zip_code
          : err_zip_code,
        errCheckbox: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_checkbox).length > 0
            ? frontLabelsName.filter((e) => e.key == err_checkbox)[0]["value"] ||
              err_checkbox
            : err_checkbox
          : err_checkbox,
      });
    } else {
      validationFlag = true;
      setErrors({
        errorName: "",
        errorEmail: "",
        errorAddress: "",
        errormobile: "",
        errorNationality: "",
        errorSs: "",
        errorZCode: "",

        errBudget: "",
        errDepositType: "",
        errDepositAmount: "",
        errFamilySize: "",
        errChild: "",
        errWorkPerson: "",
        errTypeOfWork: "",
        errSpouseOfWork: "",

        errBhk: "",
        errAvailableFrom: "",
        errAvailableTo: "",
        errOther: "",
        errAccess: "",
        errRestriction: "",
        errHomeAppliance: "",
        errPropertyType: "",
        errPriceFrom: "",
        errPriceTo: "",
        errZip: "",

        errCheckbox: "",
      });
    }
    let temptypeArray = [];
    propertyType.map((a) => temptypeArray.push(a.value));

    let temptBhkArray = [];
    bhk.map((a) => temptBhkArray.push(a.value));
    let concatedArray = selectedOtherData.concat(
      selectedAccessData,
      selectedHomeApplianceData,
      selectedRestrictionData
    );
    let c = [...new Set(concatedArray)];
    const formData = new FormData();
    formData.append("name", full_name);
    formData.append("email", email);
    formData.append("phone", mobile_number);
    formData.append("ss_number", ss_number);
    formData.append("nationality", nationality);
    formData.append("zip_code", zcode);
    formData.append("address", address);
    formData.append("profile_pic", profile_pic_url);
    for (let i = 0; i < checkedTree.length; i++) {
      formData.append("area", checkedTree[i]);
    }

    for (let i = 0; i < temptBhkArray.length; i++) {
      formData.append("bhk", temptBhkArray[i]);
    }
    for (let i = 0; i < c.length; i++) {
      formData.append("other", c[i]);
    }
    for (let i = 0; i < temptypeArray.length; i++) {
      formData.append("propertyType", temptypeArray[i]);
    }
    formData.append("priceFrom", priceFrom);
    formData.append("priceTo", priceTo);
    formData.append(
      "availabilityType",
      longTerm === true ? "longTerm" : shortTerm === true ? "shortTerm" : ""
    );
    formData.append("availabilityTo", longTerm === true ? null : availableTo);

    formData.append("availabilityFrom", availableFrom);
    formData.append("budget", budget);
    formData.append("depositType", depositType);
    formData.append("depositAmount", depositAmount);
    formData.append("familySize", familySize);

    formData.append("child", child);
    formData.append("workPerson", workPerson);
    formData.append("typeOfWork", typeOfWork);
    formData.append("spouseOfWork", spouseOfWork);

    formData.append("credit_info", creditUploadUrl);
    formData.append("recommendations", recommendationUploadUrl);
    formData.append("others", otherUploadUrl);
    if (validationFlag) {
      setDisableSubmitButton(true)
      props
        .addRentersList(formData)
        .then((res) => {
          setDisableSubmitButton(false)
          toast.success(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                    "value"
                  ] || res.data.message
                : res.data.message
              : res.data.message
          );
          history.push("/");
        })
        .catch((err) => {
          setDisableSubmitButton(false)
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == err.response.data.message
                  )[0]["value"] || err.response.data.message
                : err.response.data.message
              : err.response.data.message
          );
        });
    }
  };

  if (isAuthenticated && !loading) {
    return <Redirect to="/dashboard" />;
  }

 

  var zipcustom
  if(checkedTree&& checkedTree[0]=="0" ){
    zipcustom=""
  }else if(checkedTree&& checkedTree[0]!="0"&& checkedTree?.toString()?.length<=50){
    zipcustom=checkedTree?.toString()
  }
  else if(checkedTree&& checkedTree[0]!="0"&& checkedTree?.toString()?.length>50){
    zipcustom= checkedTree?.toString().substring(0,50) + "..."
  }

  return (
    <>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>

      <div className=" mb-5 pt-5">
        <div
          className="row "
          style={{ display: "flex", justifyContent: "center",width:"100%" }}
        >
          <div className="col-lg-7 col-md-10 col-11 ">
            <div className="register-non-user11 register-body">
              {/* <div className="otp-box-rg-new-non11"> */}
              <div className="register-content">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_subscribe_renter_non_user"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscribe_renter_non_user"
                        )[0]["value"] || "lbl_subscribe_renter_non_user"
                      : "lbl_subscribe_renter_non_user"
                    : "lbl_subscribe_renter_non_user"}
                </h2>
                {/* <FaUserCircle style={{background:'red',fontSize:'40px',padding:'',width:100}}/> */}
                <div className="img-div">
                  <img
                    src={profile_pic1 ? profile_pic1 : "assets/icons/user1.svg"}
                    className={
                      profile_pic1 ? "register_img_logo1" : "register_img_logo"
                    }
                  />
                  <FaPlusCircle
                    className="FaPlusCircle"
                    onClick={modalHandle}
                  />
                </div>
              </div>
              <div style={{ marginTop: "35px" }}>
                <FormGroup>
                  <Row className="row_style5">
                    <Col xs="12" lg="6">
                      <Input
                        type="text"
                        name="full_name"
                        placeholder={
                          `${frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_name")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_name"
                                )[0]["value"] || "lbl_name"
                              : "lbl_name"
                            : "lbl_name"}*`
                        }
                        className="input_style"
                        value={full_name}
                        onChange={(e) => setFull_name(e.target.value)}
                      />
                      {errors.errorName && (
                        <span className="invalid_span">{errors.errorName}</span>
                      )}
                    </Col>
                    <Col xs="12" lg="6">
                      <Input
                        type="text"
                        name="ss_number"
                        placeholder={
                         `${ frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_social_security_no"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_social_security_no"
                              )[0]["value"] || "lbl_social_security_no"
                            : "lbl_social_security_no"
                          : "lbl_social_security_no"}*`
                        }
                        className="input_style"
                        value={ss_number}
                        onChange={(e) => setSs_number(e.target.value)}
                      />
                      {errors.errorSs && (
                        <span className="invalid_span">{errors.errorSs}</span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Input
                    type="text"
                    name="address"
                    placeholder={
                     `${ frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_address")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_address")[0][
                            "value"
                          ] || "lbl_address"
                        : "lbl_address"
                      : "lbl_address"}*`
                    }
                    className="input_style"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  {errors.errorAddress && (
                    <span className="invalid_span">{errors.errorAddress}</span>
                  )}
                </FormGroup>
                <FormGroup>
                  <Row className="row_style5">
                    <Col xs="12" lg="6">
                      <Input
                        type="number"
                        name="zcode"
                        placeholder={
                        ` ${ frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_zip_code")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_zip_code"
                              )[0]["value"] || "lbl_zip_code"
                            : "lbl_zip_code"
                          : "lbl_zip_code"}*`
                        }
                        className="input_style"
                        value={zcode}
                        onChange={(e) => setZcode(e.target.value)}
                      />
                      {errors.errorZCode && (
                        <span className="invalid_span">
                          {errors.errorZCode}
                        </span>
                      )}
                    </Col>
                    <Col xs="12" lg="6">
                      <Input
                        type="email"
                        name="email"
                        placeholder={
                         `${ frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_email")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_email"
                              )[0]["value"] || "lbl_email"
                            : "lbl_email"
                          : "lbl_email"}*`
                        }
                        className="input_style"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.errorEmail && (
                        <span className="invalid_span">
                          {errors.errorEmail}
                        </span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row className="row_style5">
                    <Col lg="6" xs="12">
                      <Input
                        type="number"
                        name="phone"
                        placeholder={
                         `${ frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_phone_number"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_phone_number"
                              )[0]["value"] || "lbl_phone_number"
                            : "lbl_phone_number"
                          : "lbl_phone_number"}*`
                        }
                        className="input_style"
                        value={mobile_number}
                        onChange={(e) => setMobileNumber(e.target.value)}
                      />
                      {errors.errormobile && (
                        <span className="invalid_span">
                          {errors.errormobile}
                        </span>
                      )}
                    </Col>
                    <Col xs="12" lg="6">
                      <Input
                        type="text"
                        name="nationality"
                        placeholder={
                          `${frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_nationality"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_nationality"
                                )[0]["value"] || "lbl_nationality"
                              : "lbl_nationality"
                            : "lbl_nationality"}*`
                        }
                        className="input_style"
                        value={nationality}
                        onChange={(e) => setNationality(e.target.value)}
                      />
                      {errors.errorNationality && (
                        <span className="invalid_span">
                          {errors.errorNationality}
                        </span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
              </div>
              <div className="mt-5 family-info">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_family_information"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_family_information"
                        )[0]["value"] || "lbl_family_information"
                      : "lbl_family_information"
                    : "lbl_family_information"}
                </h2>
                <FormGroup className="pt-3 set-bg-feild2">
                  <Row className="row_style5">
                    <Col lg="3">
                      <select
                        className="select_style "
                        id="inputGroupSelect02"
                        value={familySize}
                        onChange={(e) => setFamilySize(e.target.value)}
                      >
                        <option selected>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_size_of_family"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_size_of_family"
                                )[0]["value"] || "lbl_size_of_family"
                              : "lbl_size_of_family"
                            : "lbl_size_of_family"}*
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6+</option>
                      </select>
                      {errors.errFamilySize && (
                        <span className="invalid_span">
                          {errors.errFamilySize}
                        </span>
                      )}
                    </Col>
                    <Col lg="4">
                      <select
                        className="select_style"
                        id="inputGroupSelect02"
                        value={child}
                        onChange={(e) => setChild(e.target.value)}
                      >
                        <option selected>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_children"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_children"
                                )[0]["value"] || "lbl_no_children"
                              : "lbl_no_children"
                            : "lbl_no_children"}*
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6+</option>
                      </select>
                      {errors.errChild && (
                        <span className="invalid_span">{errors.errChild}</span>
                      )}
                    </Col>
                    <Col lg="5">
                      <select
                        className="select_style"
                        id="inputGroupSelect02"
                        value={workPerson}
                        onChange={(e) => setWorkPerson(e.target.value)}
                      >
                        <option selected>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_of_person_work"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_of_person_work"
                                )[0]["value"] || "lbl_no_of_person_work"
                              : "lbl_no_of_person_work"
                            : "lbl_no_of_person_work"}*
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6+</option>
                      </select>
                      {errors.errWorkPerson && (
                        <span className="invalid_span">
                          {errors.errWorkPerson}
                        </span>
                      )}
                    </Col>
                 
                  </Row>
                </FormGroup>
                <FormGroup className=" set-bg-feild2">
                  <Row className="row_style5">
                    <Col xs="12" lg="6">
                      <Input
                        type="text"
                        name="man"
                        placeholder={
                         `${ frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_man_type_work"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_man_type_work"
                              )[0]["value"] || "lbl_man_type_work"
                            : "lbl_man_type_work"
                          : "lbl_man_type_work"}*`
                        }
                        className="input_style"
                        value={typeOfWork}
                        onChange={(e) => setTypeOfWork(e.target.value)}
                      />
                      {errors.errTypeOfWork && (
                        <span className="invalid_span">
                          {errors.errTypeOfWork}
                        </span>
                      )}
                    </Col>
                    <Col xs="12" lg="6">
                      <Input
                        type="text"
                        name="women"
                        placeholder={
                         `${ frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_women_type_work"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_women_type_work"
                              )[0]["value"] || "lbl_women_type_work"
                            : "lbl_women_type_work"
                          : "lbl_women_type_work"}*`
                        }
                        className="input_style"
                        value={spouseOfWork}
                        onChange={(e) => setSpouseOfWork(e.target.value)}
                      />
                      {errors.errSpouseOfWork && (
                        <span className="invalid_span">
                          {errors.errSpouseOfWork}
                        </span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup className="set-bg-feild2">
                  <Row className="row_style5">
                  
                    <Col lg="4">
                  
                      <select
                        className="select_style set-bg-feild"
                        id="inputGroupSelect02"
                        value={depositType}
                        onChange={(e) => setDepositType(e.target.value)}
                      >
                        <option selected>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_deposit_type"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_deposit_type"
                                )[0]["value"] || "lbl_deposit_type"
                              : "lbl_deposit_type"
                            : "lbl_deposit_type"}*
                        </option>
                        <option value="renters_insurance">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_renters_insurance"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_renters_insurance"
                                )[0]["value"] || "lbl_renters_insurance"
                              : "lbl_renters_insurance"
                            : "lbl_renters_insurance"}
                        </option>
                        <option value="security_deposit">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_security_deposit"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_security_deposit"
                                )[0]["value"] || "lbl_security_deposit"
                              : "lbl_security_deposit"
                            : "lbl_security_deposit"}
                        </option>
                        <option value="bank_guarantee">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_bank_guarantee"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_bank_guarantee"
                                )[0]["value"] || "lbl_bank_guarantee"
                              : "lbl_bank_guarantee"
                            : "lbl_bank_guarantee"}
                        </option>
                        <option value="collateral">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_collateral"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_collateral"
                                )[0]["value"] || "lbl_collateral"
                              : "lbl_collateral"
                            : "lbl_collateral"}
                        </option>
                        <option value="other">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_other")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_other"
                                )[0]["value"] || "lbl_other"
                              : "lbl_other"
                            : "lbl_other"}
                        </option>
                      </select>
                      {errors.errDepositType && (
                        <span className="invalid_span">
                          {errors.errDepositType}
                        </span>
                      )}
                    </Col>
                    <Col lg="4">
                      {/* <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_deposit_max_amount"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_deposit_max_amount"
                              )[0]["value"] || "lbl_deposit_max_amount"
                            : "lbl_deposit_max_amount"
                          : "lbl_deposit_max_amount"}
                      </Label> */}
                      <Input
                        type="Number"
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxlength={12}
                        placeholder={
                          `${frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_deposit_max_amount"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_deposit_max_amount"
                                )[0]["value"] || "lbl_deposit_max_amount"
                              : "lbl_deposit_max_amount"
                            : "lbl_deposit_max_amount"}*`
                        }
                        className="input_style"
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                      />
                      {errors.errDepositAmount && (
                        <span className="invalid_span">
                          {errors.errDepositAmount}
                        </span>
                      )}
                    </Col>
                    <Col lg="4">
                   
                      <Input
                        type="Number"
                        name="budget"
                        placeholder={
                          `${frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_rent_budget"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_rent_budget"
                                )[0]["value"] || "lbl_rent_budget"
                              : "lbl_rent_budget"
                            : "lbl_rent_budget"}*`
                        }
                        className="input_style"
                        value={budget}
                        onChange={(e) => setBudget(e.target.value)}
                      />
                      {errors.errBudget && (
                        <span className="invalid_span">{errors.errBudget}</span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
              </div>
              <div className="mt-5 housing-needs">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_housing_need")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_housing_need"
                        )[0]["value"] || "lbl_housing_need"
                      : "lbl_housing_need"
                    : "lbl_housing_need"}
                </h2>
                <FormGroup className=" pt-3 set-bg-feild2">
                  <Row className="row_style5">
            
                    <Col lg="6" className="mb-3">
                      <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_type_of_property"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_type_of_property"
                              )[0]["value"] || "lbl_type_of_property"
                            : "lbl_type_of_property"
                          : "lbl_type_of_property"}<span style={{color:"red"}}>*</span>
                      </Label>
                      <Select
                        value={propertyType}
                        defaultValue={propertyType}
                        isMulti="true"
                        onChange={handleChange}
                        options={options}
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_select")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_select"
                                )[0]["value"] || "lbl_select"
                              : "lbl_select"
                            : "lbl_select"
                        }
                        className="property-select_style"
                      />
                      {errors.errPropertyType && (
                        <span className="invalid_span">
                          {errors.errPropertyType}
                        </span>
                      )}
                    </Col>
                    <Col lg="6" className="mb-3">
                      {/* <Input
                          type="text"
                          placeholder="Zip Code"
                          className="input_style"
                        /> */}
                      <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_zip_code")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_zip_code"
                              )[0]["value"] || "lbl_zip_code"
                            : "lbl_zip_code"
                          : "lbl_zip_code"}<span style={{color:"red"}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="Enter Zip Code"
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_zip_code")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_zip_code"
                                )[0]["value"] || "lbl_zip_code"
                              : "lbl_zip_code"
                            : "lbl_zip_code"
                        }
                        className="select_style"
                        autocomplete="off"
                        onClick={handleZipCode}
                        value={zipcustom}
                        // style={{ color: "transparent" }}
                        // onChange={onFilterChange}
                      />
                      {errors.errZip && (
                        <span className="invalid_span">{errors.errZip}</span>
                      )}
                      {openZip && (
                        <div className="zipcode-style">
                                                              <PerfectScrollbar
                  style={{
                 
                    maxHeight:"300px",
                    overflowX: "hidden",
                  
                    width:"100%"
                  }}
            
                 
                >
                          <CheckboxTree
                            nodes={nodes}
                            checked={checkedTree}
                            expanded={expandedTree}
                            expandOnClick={true}
                            onClick={(clickedTree) =>
                              setClickedTree(clickedTree)
                            }
                            onCheck={(checkedTree) => {
                              setCheckedTree(checkedTree);
                            }}
                            onExpand={(expandedTree) =>
                              setExpandedTree(expandedTree)
                            }
                            icons={icons}
                            // nativeCheckboxes={true}
                          />
                          </PerfectScrollbar>
                        </div>
                      )}
                    </Col>
                    <Col lg="6" className="">
                      <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_bhk")
                              .length > 0
                            ? frontLabelsName.filter((e) => e.key == "lbl_bhk")[0][
                                "value"
                              ] || "lbl_bhk"
                            : "lbl_bhk"
                          : "lbl_bhk"}<span style={{color:"red"}}>*</span>
                      </Label>
               
                      <Select
                        value={bhk}
                        defaultValue={bhk}
                        isMulti="true"
                        onChange={handleBhkChange}
                        options={bhkOptions}
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_select")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_select"
                                )[0]["value"] || "lbl_select"
                              : "lbl_select"
                            : "lbl_select"
                        }
                        className="property-select_style"
                      />
                      {errors.errBhk && (
                        <span className="invalid_span">{errors.errBhk}</span>
                      )}
                    </Col>
                    <Col lg="3" className="">
                      <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_price_from")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_price_from"
                              )[0]["value"] || "lbl_price_from"
                            : "lbl_price_from"
                          : "lbl_price_from"}<span style={{color:"red"}}>*</span>
                      </Label>
                      <Input
                        type="number"
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxlength={12}
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_price_from"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_price_from"
                                )[0]["value"] || "lbl_price_from"
                              : "lbl_price_from"
                            : "lbl_price_from"
                        }
                        className="input_style"
                        value={priceFrom}
                        onChange={(e) => setPriceFrom(e.target.value)}
                      />
                      {errors.errPriceFrom && (
                        <span className="invalid_span">
                          {errors.errPriceFrom}
                        </span>
                      )}
                    </Col>
                    <Col lg="3" className="">
                      <Label className="label_style">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_price_to")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_price_to"
                              )[0]["value"] || "lbl_price_to"
                            : "lbl_price_to"
                          : "lbl_price_to"}<span style={{color:"red"}}>*</span>
                      </Label>
                      <Input
                        type="number"
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxlength={12}
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_price_to")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_price_to"
                                )[0]["value"] || "lbl_price_to"
                              : "lbl_price_to"
                            : "lbl_price_to"
                        }
                        className="input_style"
                        value={priceTo}
                        onChange={(e) => setPriceTo(e.target.value)}
                      />
                      {errors.errPriceTo && (
                        <span className="invalid_span">
                          {errors.errPriceTo}
                        </span>
                      )}
                    </Col>
                  </Row>
                </FormGroup>

                <FormGroup className="renter-input-checkbox">
                  <Label className="label_style ps-0">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_home_appliances"
                          )[0]["value"] || "lbl_home_appliances"
                        : "lbl_home_appliances"
                      : "lbl_home_appliances"}
                  </Label>
                  <Row>
                    {homeApplianceType?.length > 0 &&
                      homeApplianceType.map((inc, i) => {
                        return (
                          <Col lg="3" md="3" className="checkbox-styles ">
                            <Input
                              id={inc._id}
                              type="checkbox"
                              className="input_style"
                              value={inc._id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedHomeApplianceData([
                                    ...selectedHomeApplianceData,
                                    e.target.value,
                                  ]);
                                } else {
                                  const filterVal =
                                    selectedHomeApplianceData.filter(
                                      (val, i) => val !== e.target.value
                                    );
                                  setSelectedHomeApplianceData(filterVal);
                                }
                              }}
                              checked={selectedHomeApplianceData?.includes(
                                inc._id
                              )}
                            />
                            <Label className="pt-2" htmlFor={inc._id}>
                        
                               {Array.isArray(inc?.name) ? inc?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:inc?.name }
                            </Label>
                          </Col>
                        );
                      })}

                    {errors.errHomeAppliance && (
                      <span className="invalid_span">
                        {errors.errHomeAppliance}
                      </span>
                    )}
                  </Row>
                </FormGroup>
                <FormGroup className="renter-input-checkbox">
                  <Label className="label_style ps-0">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_restrictions"
                          )[0]["value"] || "lbl_restrictions"
                        : "lbl_restrictions"
                      : "lbl_restrictions"}
                  </Label>
                  <Row>
                    {restrictionsType?.length > 0 &&
                      restrictionsType.map((inc, i) => {
                        return (
                          <Col lg="3" md="3" className="checkbox-styles ">
                            <Input
                              id={inc._id}
                              type="checkbox"
                              className="input_style"
                              value={inc._id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedRestrictionData([
                                    ...selectedRestrictionData,
                                    e.target.value,
                                  ]);
                                } else {
                                  const filterVal =
                                    selectedRestrictionData.filter(
                                      (val, i) => val !== e.target.value
                                    );
                                  setSelectedRestrictionData(filterVal);
                                }
                              }}
                              checked={selectedRestrictionData?.includes(
                                inc._id
                              )}
                            />
                            <Label className="pt-2" htmlFor={inc._id}>
                           
                            {Array.isArray(inc?.name) ? inc?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:inc?.name }
                            </Label>
                          </Col>
                        );
                      })}

                    {errors.errRestriction && (
                      <span className="invalid_span">
                        {errors.errRestriction}
                      </span>
                    )}
                  </Row>
                </FormGroup>
                <FormGroup className="renter-input-checkbox">
                  <Label className="label_style ps-0">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_access").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_access")[0][
                            "value"
                          ] || "lbl_access"
                        : "lbl_access"
                      : "lbl_access"}
                  </Label>
                  <Row>
                    {accessType?.length > 0 &&
                      accessType.map((inc, i) => {
                        return (
                          <Col lg="3" md="3" className="checkbox-styles ">
                            <Input
                              id={inc._id}
                              type="checkbox"
                              className="input_style"
                              value={inc._id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedAccessData([
                                    ...selectedAccessData,
                                    e.target.value,
                                  ]);
                                } else {
                                  const filterVal = selectedAccessData.filter(
                                    (val, i) => val !== e.target.value
                                  );
                                  setSelectedAccessData(filterVal);
                                }
                              }}
                              checked={selectedAccessData?.includes(inc._id)}
                            />
                            <Label className="pt-2" htmlFor={inc._id}>
                              
                            {Array.isArray(inc?.name) ? inc?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:inc?.name }
                            </Label>
                          </Col>
                        );
                      })}

                    {errors.errAccess && (
                      <span className="invalid_span">{errors.errAccess}</span>
                    )}
                  </Row>
                </FormGroup>
                <FormGroup className="renter-input-checkbox">
                  <Label className="label_style ps-0">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_other").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                            "value"
                          ] || "lbl_other"
                        : "lbl_other"
                      : "lbl_other"}
                  </Label>
                  <Row>
                    {otherTypeField?.length > 0 &&
                      otherTypeField.map((inc, i) => {
                        return (
                          <Col lg="3" md="3" className="checkbox-styles ">
                            <Input
                              id={inc._id}
                              type="checkbox"
                              className="input_style"
                              value={inc._id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedOtherData([
                                    ...selectedOtherData,
                                    e.target.value,
                                  ]);
                                } else {
                                  const filterVal = selectedOtherData.filter(
                                    (val, i) => val !== e.target.value
                                  );
                                  setSelectedOtherData(filterVal);
                                }
                              }}
                              checked={selectedOtherData?.includes(inc._id)}
                            />
                            <Label className="pt-2" htmlFor={inc._id}>
                      
                            {Array.isArray(inc?.name) ? inc?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:inc?.name }
                            </Label>
                          </Col>
                        );
                      })}
                  
                    {errors.errOther && (
                      <span className="invalid_span">{errors.errOther}</span>
                    )}
                  </Row>
                </FormGroup>
              </div>
              <div className="mt-5 d-flex rental-length">
                <Row className="row_style1">
                  <h2>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_length_rental")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_length_rental"
                          )[0]["value"] || "lbl_length_rental"
                        : "lbl_length_rental"
                      : "lbl_length_rental"}
                  </h2>
                  <Col
                    lg="5"
                    md="5"
                    sm="5"
                    xs="12"
                    className="checkbox-styles1"
                  >
                    <div className="field-group21">
                      <label htmlFor="16">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_short_term")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_short_term"
                              )[0]["value"] || "lbl_short_term"
                            : "lbl_short_term"
                          : "lbl_short_term"}
                      </label>
                      <input
                        id="16"
                        type="checkbox"
                        value={shortTerm}
                        name="availableType"
                        onChange={() => {
                          if (shortTerm !== true) {
                            setLongTerm(false);
                            setShortTerm(true);
                          }
                        }}
                        checked={shortTerm === true}
                      />
                    </div>
                  </Col>
                  <Col
                    lg="5"
                    md="5"
                    sm="5"
                    xs="12"
                    className="checkbox-styles1"
                  >
                    {/* <Label for="html">Long Term</Label>
                          <Input type="radio" id="html" name="fav_language" value="HTML"/> */}
                    <div className="field-group21">
                      <label htmlFor="17">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_long_term")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_long_term"
                              )[0]["value"] || "lbl_long_term"
                            : "lbl_long_term"
                          : "lbl_long_term"}
                      </label>
                      <input
                        id="17"
                        type="checkbox"
                        value={longTerm}
                        name="availableType"
                        onChange={() => {
                          if (longTerm !== true) {
                            setLongTerm(true);
                            setShortTerm(false);
                          }
                        }}
                        checked={longTerm === true}
                      />
                    </div>
                  </Col>
              
                </Row>
              </div>
              <div className="mt-2 d-flex rental-length">
                <Row>
                  <FormGroup className="pt-2">
                    <Row className="row_style5">
                      <Col
                        lg={shortTerm ? "6" : "12"}
                        xs={shortTerm ? "6" : "12"}
                      >
                        <Label className="label_style">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_from")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_from"
                                )[0]["value"] || "lbl_from"
                              : "lbl_from"
                            : "lbl_from"}<span style={{color:"red"}}>*</span>
                        </Label>
                   
                        <div style={{ position: "relative" }}>
                          <FaCalendarAlt className="date-icon-style" />
                          <DatePicker
                            selected={availableFrom}
                            onChange={(date) => setAvailableFrom(date)}
                            dateFormat="dd/MM/yyyy"
                            // openToDate={new Date("1993/09/28")}
                            placeholderText={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_available_from"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_from"
                                    )[0]["value"] || "lbl_available_from"
                                  : "lbl_available_from"
                                : "lbl_available_from"
                            }
                            className="date_style"
                            minDate={new Date()}
                          />
                        </div>

                        {errors.errAvailableFrom && (
                          <span className="invalid_span">
                            {errors.errAvailableFrom}
                          </span>
                        )}
                      </Col>
                      {shortTerm && (
                        <Col lg="6" xs="6">
                          <Label className="label_style">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_to")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_to"
                                  )[0]["value"] || "lbl_to"
                                : "lbl_to"
                              : "lbl_to"}<span style={{color:"red"}}>*</span>
                          </Label>
                          <div style={{ position: "relative" }}>
                            <FaCalendarAlt
                              className="date-icon-style"
                              // style={{
                              //   position: "absolute",
                              //   top: 17,
                              //   zIndex: 40,
                              //   left: 8,
                              //   color: "#8B9194",
                              // }}
                            />
                            <DatePicker
                              selected={availableTo}
                              onChange={(date) => setAvailableTo(date)}
                              dateFormat="dd/MM/yyyy"
                              // openToDate={new Date("1993/09/28")}
                              placeholderText={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_to"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_available_to"
                                      )[0]["value"] || "lbl_available_to"
                                    : "lbl_available_to"
                                  : "lbl_available_to"
                              }
                              className="date_style"
                              minDate={new Date()}
                            />
                          </div>
                          {errors.errAvailableTo && (
                            <span className="invalid_span">
                              {errors.errAvailableTo}
                            </span>
                          )}
                        </Col>
                      )}
                    </Row>
                  </FormGroup>

               
                </Row>
              </div>
              <div className="mt-4  attachments">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_attachments")
                        .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_attachments")[0][
                          "value"
                        ] || "lbl_attachments"
                      : "lbl_attachments"
                    : "lbl_attachments"}
                </h2>
               <em> (
                {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == 'lbl_image_with_pdf_validation_msg')
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == 'lbl_image_with_pdf_validation_msg'
                  )[0]['value'] || 'lbl_image_with_pdf_validation_msg'
                : 'lbl_image_with_pdf_validation_msg'
              : 'lbl_image_with_pdf_validation_msg'}
            )</em>
                <FormGroup
                  className="pt-3 "
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    gap: 20,
                    flexWrap: "wrap",
                  }}
                >
              
                  <div style={{display:"flex",flexDirection:"column"}}>
                    <Button
                      className="btn-1"
                      variant="contained"
                      component="label"
                      color="secondary"
                    >
                      <IconButton onClick={handleCreditUpload}>
                        <UploadFileRoundedIcon className="icon-style" />
                      </IconButton>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_credit_info")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_credit_info"
                            )[0]["value"] || "lbl_credit_info"
                          : "lbl_credit_info"
                        : "lbl_credit_info"}
                      <input
                        type="file"
                        id="imgupload"
                        style={{ display: "none" }}
                        onChange={handleFileChange1}
                      />
                    </Button>
                    {creditImageError && (
                            <span className="invalid_span    mt-1">
                              {creditImageError}
                            </span>
                          )}
                    <br />
                    {!creditType && creditUploadPreview && (
                      <img
                        src={creditUploadPreview}
                        alt="preview"
                        width="200px"
                        height="200px"
                  
                      />
                    )}
                    {creditType && (
                      <>
                        <Row className="row_style1 row">
                          <Col lg="8" xs="12">
                            <div className="acchtements-main">
                              <div className="ach-desc d-flex">
                                <div className="col-lg-1">
                                  <img src="assets/pin.png" alt="pin" />
                                </div>
                                <div className="col-lg-11 ms-2">
                                  <p style={{minWidth:"max-content"}}>
                                    {creditFileName ? creditFileName :`$frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_credit_info"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_credit_info"
                                          )[0]["value"] || "lbl_credit_info"
                                        : "lbl_credit_info"
                                      : "lbl_credit_info"}
                                      .pdf  ` }
                                  </p>
                                </div>
                       
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                 
                  <div  style={{display:"flex",flexDirection:"column"}}>
                    <Button
                      className="btn-1"
                      variant="contained"
                      component="label"
                      color="secondary"
                    >
                      <IconButton onClick={handleRecommendationUpload}>
                        <UploadFileRoundedIcon className="icon-style" />
                      </IconButton>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_recommendation"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_recommendation"
                            )[0]["value"] || "lbl_recommendation"
                          : "lbl_recommendation"
                        : "lbl_recommendation"}
                      <input
                        type="file"
                        id="imgupload2"
                        style={{ display: "none" }}
                        onChange={handleFileChange2}
                      />
                    </Button>
                    {reccomendationImageError && (
                            <span className="invalid_span mt-1">
                              {reccomendationImageError}
                            </span>
                          )}
                    <br />
                    {!recommendationType && recommendationUploadPreview && (
                      <img
                        src={recommendationUploadPreview}
                        alt="preview"
                        width="200px"
                        height="200px"
                        className="mt-2"
                      />
                    )}
                    {recommendationType && (
                      <>
                        <Row className="row_style1 row">
                          <Col lg="8" xs="12">
                            <div className="acchtements-main">
                              <div className="ach-desc d-flex">
                                <div className="col-lg-1">
                                  <img src="assets/pin.png" alt="pin" />
                                </div>
                                <div className="col-lg-7 ms-2">
                                  <p  style={{minWidth:"max-content"}}>
                                  {recomendationFileName ? recomendationFileName :`${frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_recommendation"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_recommendation"
                                          )[0]["value"] || "lbl_recommendation"
                                        : "lbl_recommendation"
                                      : "lbl_recommendation"}
                                  .pdf  ` }
                                  </p>
                                </div>
                      
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
               
                  <div  style={{display:"flex",flexDirection:"column"}}>
                    <Button
                      className="btn-1"
                      variant="contained"
                      component="label"
                      color="secondary"
                    >
                      <IconButton onClick={handleOtherUpload}>
                        <UploadFileRoundedIcon className="icon-style" />
                      </IconButton>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_other")
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                              "value"
                            ] || "lbl_other"
                          : "lbl_other"
                        : "lbl_other"}
                      <input
                        type="file"
                        id="imgupload3"
                        style={{ display: "none" }}
                        onChange={handleFileChange3}
                      />
                    </Button>
                    {otherImageError && (
                            <span className="invalid_span mt-1">
                              {otherImageError}
                            </span>
                          )}
                    <br />

                    {!otherType && otherUploadPreview && (
                      <img
                        src={otherUploadPreview}
                        alt="preview"
                        width="200px"
                        height="200px"
                        className="mt-2"
                      />
                    )}
                  
                    {otherType && (
                      <>
                        <Row className="row_style1 row">
                          <Col lg="8" xs="12">
                            <div className="acchtements-main">
                              <div className="ach-desc d-flex">
                                <div className="col-lg-1">
                                  <img src="assets/pin.png" alt="pin" />
                                </div>
                                <div className="col-lg-7 ms-3">
                                  <p  style={{minWidth:"max-content"}}>
                                    {" "}
                                    {otherFileName ? otherFileName :`${frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_other"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_other"
                                          )[0]["value"] || "lbl_other"
                                        : "lbl_other"
                                      : "lbl_other"}
                                     .pdf  ` }
                                  </p>
                                </div>
                                {/* <div className="col-lg-2">
                <img
                  src="assets/bin.svg"
                  alt="pin"
                  className="bin-ah"
                />
              </div> */}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                    {/* </Col> */}
                  </div>
                  {/* </Row> */}
                </FormGroup>
              </div>
              <div className="agreement-style mt-4 align-items-center">
                <input
                  type="checkbox"
                  id="agreement"
                  checked={termsCheckbox}
                  onChange={(e) => setTermsCheckbox(e.target.checked)}
                />
                <label htmlFor="agreement" className="ps-2">
                  {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_agree_term_condition"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_agree_term_condition"
                        )[0]["value"] || "lbl_agree_term_condition"
                      : "lbl_agree_term_condition"
                    : "lbl_agree_term_condition"}
                </label>
              </div>
              {errors.errCheckbox && (
                <span className="invalid_span">{errors.errCheckbox}</span>
              )}

              <div className="text-center mt-2  pt-4 regis-btn-style">
                {/* <Row style={{ display: "flex", justifyContent: "center",alignItems:'center' }}> */}
                {/* <Col lg="5" sm="6" xs="8"> */}

                <button className="btn-style2" onClick={subscribeHandler}>
                  {disableSubmitButton ? (
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                      ) :frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_subscribe")
                        .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_subscribe")[0][
                          "value"
                        ] || "lbl_subscribe"
                      : "lbl_subscribe"
                    : "lbl_subscribe"}
                </button>

                {/* </Col> */}
                {/* </Row> */}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>

      {/* model for profile image upload */}

      <Modal isOpen={modal} modalHandle={modalHandle}>
        <ModalHeader modalHandle={modalHandle}>
          {frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_add_profile_pic").length >
              0
              ? frontLabelsName.filter((e) => e.key == "lbl_add_profile_pic")[0][
                  "value"
                ] || "lbl_add_profile_pic"
              : "lbl_add_profile_pic"
            : "lbl_add_profile_pic"}
        </ModalHeader>
        <ModalBody>
          <div className="custom-file-input4">
            <Button
              variant="contained"
              // onClick={handleUpload}
              component="label"
              className="upload-button-style1"
            >
              <FaFileUpload
                style={{
                  marginRight: 10,
                  color: "#8B9194",
                }}
              />
              {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_upload_file").length >
                  0
                  ? frontLabelsName.filter((e) => e.key == "lbl_upload_file")[0][
                      "value"
                    ] || "lbl_upload_file"
                  : "lbl_upload_file"
                : "lbl_upload_file"}

              <input
                onChange={handleFileChange}
                hidden
                accept="image/*"
                multiple
                type="file"
                className="custom-file-input1"
                id="handleupload"
              />
            </Button>
            {/* <input
              type="file"
              placeholder={frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_upload_file")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_upload_file"
                    )[0]["value"] || "lbl_upload_file"
                  : "lbl_upload_file"
                : "lbl_upload_file"}
              onChange={handleFileChange}
              accept="image/*"
              className="custom-file-input1"
              id="handleupload"
            />
            <FaFileUpload
              style={{
                position: "absolute",
                top: 34,
                left: 35,
                color: "#8B9194",
              }}
            /> */}

            {profile_pic2 ? (
              <img
                src={profile_pic2}
                alt="preview"
                width="150px"
                height="150px"
              />
            ) : profile_pic1 ? (
              <img
                src={profile_pic1}
                alt="preview"
                width="150px"
                height="150px"
              />
            ) : (
              <img
                src="assets/icons/user1.svg"
                alt="preview"
                width="150px"
                height="150px"
              />
            )}
          </div>
          <br />
          {errorProfile && <span className="invalid_span">{errorProfile}</span>}
          <p style={{ marginTop: 10, fontSize: 12 }}>
            (
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_image_validation_msg")
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_image_validation_msg"
                  )[0]["value"] || "lbl_image_validation_msg"
                : "lbl_image_validation_msg"
              : "lbl_image_validation_msg"}
            )
          </p>
        </ModalBody>
        <ModalFooter className="model-btn-styling">
        <Button onClick={cancelImage} className="cancel-button me-2">
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_cancel").length > 0
                ? frontLabelsName.filter((e) => e.key == "lbl_cancel")[0]["value"] ||
                  "lbl_cancel"
                : "lbl_cancel"
              : "lbl_cancel"}
          </Button>
          <Button
            className="confirm-button "
            onClick={confirmImage}
            disabled={profile_pic_url1 ? false : true}
          >
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_confirm").length > 0
                ? frontLabelsName.filter((e) => e.key == "lbl_confirm")[0][
                    "value"
                  ] || "lbl_confirm"
                : "lbl_confirm"
              : "lbl_confirm"}
          </Button>{" "}
      
        </ModalFooter>
      </Modal>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});
export default connect(mapStateToProps, {
  addRentersList,
  dropdownPropertyField,
})(Non_registered_user1);
